export default __webpack_public_path__ + "static/media/receipt.d6c3b740.svg";